import { Toaster } from "components";

import { invoicesConstants } from '../constants';

import { func_validation, func_serviceHandling } from 'functions';

import { promiseInstance_authorization } from './config';



export const invoicesActions = {
	getGeneralInvoices,
	getCompanyInvoices,
}

function getGeneralInvoices(pageNo, pageSize, sort, filterOptions) {
	return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let accountCode = func_validation.getObjectPropertyValue(filterOptions, "accountCode","");
		let billNo = func_validation.getObjectPropertyValue(filterOptions, "billNo","");

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			accountCode: accountCode,
			billNo: billNo,
		}

		let url = func_serviceHandling.createUrlWithParams('/Invoice/Search', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
	}
	
    function request(details) { return { type: invoicesConstants.getGeneralInvoices_request, details }; }
    function success(details) { return { type: invoicesConstants.getGeneralInvoices_success, details }; }
    function failure(error) { return { type: invoicesConstants.getGeneralInvoices_failure, error }; }
}

function getCompanyInvoices(pageNo, pageSize, sort, filterOptions) {
	return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let accountCode = func_validation.getObjectPropertyValue(filterOptions, "accountCode","");
		let billNo = func_validation.getObjectPropertyValue(filterOptions, "billNo","");

		let paramObj = {
			offset: offset,
			limit: pageSize,
			sort: sort,
			accountCode: accountCode,
			billNo: billNo,
		}

		let url = func_serviceHandling.createUrlWithParams('/Invoice/SearchInvoiceItem', paramObj)

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
	}
	
    function request(details) { return { type: invoicesConstants.getCompanyInvoices_request, details }; }
    function success(details) { return { type: invoicesConstants.getCompanyInvoices_success, details }; }
    function failure(error) { return { type: invoicesConstants.getCompanyInvoices_failure, error }; }
}